import { apiClient } from "@base/api/client";
import type { PaginationResponse } from "@base/model/types";
import type { Payment } from "@features/membership/model/types";

/**
 * GET /82office/payment/api/history
 * 결제 내역 조회 (페이지네이션)
 */
export async function fetchPaymentHistory(page: number, pageSize: number): Promise<PaginationResponse<Payment[]>> {
  const { data } = await apiClient.get<PaginationResponse<Payment[]>>("/82office/payment/api/history", {
    params: { page, page_size: pageSize },
  });
  return data;
}

/*
 * TanStack Query 사용 예시:
 *
 * import { useQuery } from "@tanstack/react-query";
 * import { fetchPaymentHistory } from "@features/membership/api/paymentHistory";
 *
 * const [page, setPage] = useState(1);
 * const { data, isLoading } = useQuery({
 *   queryKey: ["paymentHistory", page],
 *   queryFn: () => fetchPaymentHistory(page, 10),
 * });
 */
